const CSS_URL = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600&family=Plus+Jakarta+Sans:wght@500;600;700&display=swap";
let cached = null;

const toDataUrl = (blob) => new Promise((res) => { const fr = new FileReader(); fr.onload = () => res(fr.result); fr.readAsDataURL(blob); });

// Latin-only @font-face rules with inlined woff2, so image export stays fast.
export function cardFontCSS() {
  if (!cached) {
    cached = (async () => {
      const css = await (await fetch(CSS_URL)).text();
      const blocks = css.split("@font-face").slice(1).map((b) => "@font-face" + b.split("}")[0] + "}");
      const latin = blocks.filter((b) => /unicode-range:\s*U\+0000-00FF/.test(b));
      const out = await Promise.all(latin.map(async (b) => {
        const url = b.match(/url\((https:[^)]+)\)/)[1];
        return b.replace(url, await toDataUrl(await (await fetch(url)).blob()));
      }));
      return out.join("\n");
    })().catch(() => { cached = null; return ""; });
  }
  return cached;
}
